import { AnySourceData } from "mapbox-gl";

import {
  CustomSelectLinkResultsTileService,
  ExtendedDirectionalRoadsTileService,
  ExtendedNonDirectionalRoadsTileService,
} from "types";

export const ROADS_SOURCE_ID = "ROADS_SOURCE_ID";

export const getRoadsSources = (
  tileService:
    | ExtendedDirectionalRoadsTileService
    | ExtendedNonDirectionalRoadsTileService
    | CustomSelectLinkResultsTileService,
  indexes?: number[],
) => {
  return [
    {
      id: ROADS_SOURCE_ID,
      source: {
        type: "vector",
        tiles: [tileService.url + "/{z}/{x}/{y}.pbf"],
        promoteId: {
          [tileService.layerName]: tileService.fromToSegmentIndexField,
        },
        minzoom: tileService.minZoom,
        maxzoom: tileService.maxZoom,
        filter: indexes ? ["in", tileService.fromToSegmentIndexField, ...indexes] : undefined,
      } as AnySourceData,
    },
  ];
};
